var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTrustLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6809 0.764648H14.9606L0.325684 15.4091V36.1202L14.9705 50.7646H35.6908L50.3355 36.1202V15.4091L35.6809 0.764648Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3311 10.7647C23.9518 10.7636 22.5859 11.0344 21.3114 11.5617C20.037 12.0891 18.879 12.8625 17.9037 13.8378C16.9284 14.8131 16.155 15.971 15.6277 17.2455C15.1003 18.52 14.8295 19.8859 14.8306 21.2652C14.8306 29.1394 25.3311 40.7646 25.3311 40.7646C25.3311 40.7646 35.8304 29.1394 35.8304 21.2652C35.8315 19.886 35.5607 18.5202 35.0335 17.2458C34.5063 15.9714 33.7329 14.8134 32.7577 13.8382C31.7826 12.8629 30.6247 12.0895 29.3504 11.5621C28.0761 11.0347 26.7103 10.7637 25.3311 10.7647Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.611 25.6778L30.97 18.2514L29.3929 16.6624L23.611 22.4998L21.2776 20.144L19.7004 21.7331L23.611 25.6778Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTrustLocation);
export default __webpack_public_path__ + "static/media/alert_trust_location.31b35bd4fde7925eb885118a77125fd1.svg";
export { ForwardRef as ReactComponent };